(function(){
var $=function(s,r){return (r||document).querySelector(s);};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
var money=function(cents){
return new Intl.NumberFormat('en-IN',{style:'currency',currency:window.DERMALISS_CURRENCY||'INR',maximumFractionDigits:2}).format(cents/100);
};
function header(){
var nav=$('.nav'),hero=$('.hero');
if(!nav)return;
if(!hero){nav.classList.add('solid');return;}
new IntersectionObserver(function(e){nav.classList.toggle('solid',!e[0].isIntersecting);},{rootMargin:'-70px 0px 0px 0px'}).observe(hero);
}
function mobileNav(){
var menu=$('.mnav');if(!menu)return;
var open=function(v){menu.classList.toggle('open',v);document.body.style.overflow=v?'hidden':'';};
var b=$('.burger');if(b)b.onclick=function(){open(true);};
var c=$('.mnav .close');if(c)c.onclick=function(){open(false);};
$$('.mnav a').forEach(function(a){a.addEventListener('click',function(){open(false);});});
document.addEventListener('keydown',function(e){if(e.key==='Escape')open(false);});
}
function scrollers(){
$$('[data-scroller],[data-shelf]').forEach(function(sec){
var track=$('[data-track]',sec)||$('.shelf',sec);if(!track)return;
var step=function(){var kid=track.firstElementChild;return kid?kid.offsetWidth+16:320;};
var p=$('[data-prev]',sec),n=$('[data-next]',sec);
if(p)p.onclick=function(){track.scrollBy({left:-step()});};
if(n)n.onclick=function(){track.scrollBy({left:step()});};
});
}
function words(){
$$('[data-words]').forEach(function(el){
var list=el.dataset.words.split(',').map(function(s){return s.trim();}).filter(Boolean);
if(list.length<2)return;
var i=0;
setInterval(function(){
el.classList.add('out');
setTimeout(function(){
i=(i+1)%list.length;
el.textContent=list[i];
el.classList.toggle('alt',i%2===1);
el.classList.remove('out');
},500);
},2800);
});
}
function videoSound(){
$$('[data-sound]').forEach(function(btn){
var stage=btn.closest('.stage');
var v=stage?$('video',stage):null;
if(!v){btn.remove();return;}
btn.onclick=function(){v.muted=!v.muted;btn.textContent=v.muted?'Sound on':'Sound off';};
});
}
function reveal(){
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.12});
$$('.rise').forEach(function(el,i){el.style.transitionDelay=(i%4)*80+'ms';io.observe(el);});
}
function qty(){
document.addEventListener('click',function(e){
var btn=e.target.closest('[data-qty]');if(!btn)return;
var input=$('input',btn.parentNode);
input.value=Math.max(1,(parseInt(input.value,10)||1)+parseInt(btn.dataset.qty,10));
input.dispatchEvent(new Event('change',{bubbles:true}));
});
}
function gallery(){
var g=$('[data-gallery]');if(!g)return;
var main=$('.shot img',g);if(!main)return;
$$('.thumbs button',g).forEach(function(b){
b.onclick=function(){
main.src=b.dataset.full;main.srcset='';
$$('.thumbs button',g).forEach(function(x){x.setAttribute('aria-current','false');});
b.setAttribute('aria-current','true');
};
});
}
function variants(){
var form=$('[data-product-form]');if(!form)return;
var data=$('[data-variants]');if(!data)return;
var list=JSON.parse(data.textContent);
var idField=$('[name=\"id\"]',form);
var priceEl=$('[data-price]'),wasEl=$('[data-price-was]');
var submit=$('[data-add]',form);
function sync(){
var chosen=$$('input[data-option]:checked',form).map(function(i){return i.value;});
if(!chosen.length)return;
var match=list.filter(function(v){return v.options.every(function(o,i){return o===chosen[i];});})[0];
if(!match)return;
idField.value=match.id;
if(priceEl)priceEl.textContent=money(match.price);
if(wasEl)wasEl.textContent=match.compare_at_price>match.price?money(match.compare_at_price):'';
if(submit){submit.classList.toggle('is-disabled',!match.available);submit.textContent=match.available?submit.dataset.addLabel:submit.dataset.soldout;}
if(history.replaceState){var u=new URL(window.location.href);u.searchParams.set('variant',match.id);history.replaceState({},'',u);}
}
$$('input[data-option]',form).forEach(function(i){i.addEventListener('change',sync);});
sync();
}
function drawerOpen(v){
var d=$('.cd'),s=$('.cd-scrim');
if(!d)return;
d.classList.toggle('open',v);
if(s)s.classList.toggle('open',v);
document.body.style.overflow=v?'hidden':'';
}
function bindCart(){
var c=$('[data-cart-close]');
if(c)c.onclick=function(){drawerOpen(false);};
}
function refreshCart(open){
return fetch('/?sections=cart-drawer').then(function(r){return r.json();}).then(function(json){
var host=document.getElementById('shopify-section-cart-drawer');
if(host&&json['cart-drawer']){host.outerHTML=json['cart-drawer'];bindCart();}
return fetch('/cart.js').then(function(r){return r.json();});
}).then(function(cart){
$$('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
if(open)drawerOpen(true);
});
}
function cart(){
document.addEventListener('click',function(e){
if(e.target.closest('.cd-scrim')){drawerOpen(false);return;}
var opener=e.target.closest('[data-cart-open]');
if(opener&&document.body.dataset.drawer){e.preventDefault();refreshCart(true);return;}
var rm=e.target.closest('[data-remove]');
if(rm){
e.preventDefault();
fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:rm.dataset.remove,quantity:0})}).then(function(){
if(document.body.classList.contains('tpl-cart'))window.location.reload();else refreshCart(false);
});
}
});
document.addEventListener('change',function(e){
var q=e.target.closest('[data-line-qty]');if(!q)return;
fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:q.dataset.lineQty,quantity:parseInt(q.value,10)||1})}).then(function(){
if(document.body.classList.contains('tpl-cart'))window.location.reload();else refreshCart(false);
});
});
document.addEventListener('submit',function(e){
var form=e.target.closest('[data-product-form]');if(!form)return;
if(!document.body.dataset.drawer)return;
e.preventDefault();
var btn=$('[data-add]',form);
var label=btn?btn.textContent:'';
if(btn){btn.classList.add('is-disabled');btn.textContent='Adding...';}
fetch('/cart/add.js',{method:'POST',body:new FormData(form)}).then(function(r){return r.json();}).then(function(res){
if(res.status)throw new Error(res.description||'Could not add to cart');
return refreshCart(true);
}).catch(function(err){
var box=$('[data-form-error]',form);
if(box)box.textContent=err.message;
}).then(function(){
if(btn){btn.classList.remove('is-disabled');btn.textContent=label;}
});
});
bindCart();
}
document.addEventListener('DOMContentLoaded',function(){
header();mobileNav();scrollers();words();videoSound();reveal();qty();gallery();variants();cart();
});
})();